import { useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

function Logo() {
  const theme = useTheme();

  return (
    <div style={{ padding: '0 20px' }}>
      <Link to="/overview" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: 12, height: 25, minHeight: 0 }}>
        <img
          src="/sirothost.png"
          alt="Sirot Logo"
          style={{ height: 38, width: 'auto', display: 'block' }}
        />
        <span style={{ fontSize: 22, letterSpacing: 1, color: '#fff', fontFamily: 'Optima, Segoe, Segoe UI, Candara, Calibri, Arial, sans-serif', fontStyle: 'italic', fontWeight: 'bold', whiteSpace: 'nowrap', alignContent: 'center', textShadow: '2px 2px 6px rgba(0,0,0,0.5)' }}>
          SIROTADMIN
        </span>
      </Link>
    </div>
  );
}

export default Logo;
